/**
 * changement-adresse-accesd
 *
 * Contact: DPSL_UNICODES@desjardins.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Compte vmd (PEVMD), disnat (ESCPT) et gpd (GPD) pour lesquels des notification de changement d\'adresse doivent être envoyées
 */
export interface CompteSCGP {
  /**
   * Numéro de compte
   */
  numeroCompte?: string;
  /**
   * Code division du compte
   */
  codeDivision?: CompteSCGPCodeDivisionEnum;
  /**
   * Description du compte
   */
  descriptionCompte?: string;
  /**
   * Description de la division du compte
   */
  descriptionDivision?: string;
}
export enum CompteSCGPCodeDivisionEnum {
  PEVMD = 'PEVMD',
  ESCPT = 'ESCPT',
  GPD = 'GPD',
}
